document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById(
    'btnToGooglemap'
  ) as HTMLAnchorElement | null;
  if (!btn) return;

  btn.addEventListener('click', (e) => {
    e.preventDefault(); // デフォルト遷移を止めて安全に生成

    // --- 出発地を取得 ---
    const startRadio = document.querySelector<HTMLInputElement>(
      'input[name="start"]:checked'
    );
    const startText = document.querySelector<HTMLInputElement>(
      'input[name="start_point"]'
    );
    let startPoint = '';

    if (startRadio?.value === '任意' && startText?.value.trim()) {
      startPoint = startText.value.trim();
    } else if (startRadio) {
      startPoint = startRadio.value;
    }

    // --- 目的地を取得 ---
    const purposeRadio = document.querySelector<HTMLInputElement>(
      'input[name="purpose"]:checked'
    );
    const purposeText = document.querySelector<HTMLInputElement>(
      'input[name="purpose_point"]'
    );
    let purposePoint = '';

    if (purposeRadio?.value === '任意' && purposeText?.value.trim()) {
      purposePoint = purposeText.value.trim();
    } else if (purposeRadio) {
      purposePoint = purposeRadio.value;
    }

    // --- URL生成 ---
    if (!startPoint || !purposePoint) {
      alert('出発地と目的地を入力または選択してください');
      return;
    }

    const encodedStart = encodeURIComponent(startPoint);
    const encodedPurpose = encodeURIComponent(purposePoint);
    const googleMapUrl = `https://www.google.co.jp/maps/dir/${encodedStart}/${encodedPurpose}`;

    // hrefにセットして開く
    btn.href = googleMapUrl;
    window.open(googleMapUrl, '_blank');
  });
});
